import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

class ImportacaoProdutos extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;

        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.IMPORTACAO_PRODUTOS)
            return null;

        const importacao = props.importacaoProdutos;

        if (!importacao.events)
            return (
                <div>
                    <h1 className="page-header">Importar planilha de produtos e cursos</h1>

                    <h2>Nenhum evento registrado.</h2>
                </div>
            );

        const token = props.token;

        const onUploadFile = (e) => {
            e.preventDefault();

            if (!this.file.files[0])
                return;

            props.events.onImportSheetProdutos(
                this.file.files[0],
                importacao.selectEvent,
                function () {
                    $(this.file).val('');
                }.bind(this),
                token);
        };

        const onChangeEvent = function (e) {
            e.preventDefault();
            props.events.onSelectEventForImportacao(e.target.value);
        };

        const tableFails = !importacao.fails ?
            null :
            <div>
                <br />
                <table className="table table-bordered table-condensed table-striped">
                    <caption>Erros de importação</caption>
                    <thead>
                        <tr>
                            <th>Linha</th>
                            <th>Error</th>
                        </tr>
                    </thead>
                    <tbody>
                    {importacao.fails.map(function (fail) {
                        return (
                            <tr key={fail.line}>
                                <td><small>{fail.line}</small></td>
                                <td><small>{fail.error}</small></td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>;

        return (
            <div>
                <h1 className="page-header">Importar planilha de produtos e cursos</h1>

                <div>
                    <form encType="multipart/form-data" >
                        <div className="form-group">
                            <label>Evento:</label>
                            <select value={importacao.selectEvent ? importacao.selectEvent.id : ""}
                                    onChange={onChangeEvent}
                                    disabled={importacao.processing === true}
                                    className="form-control">
                                {importacao.events.map(function (event) {
                                    return <option key={event.id} value={event.id}>{event.name}</option>
                                })}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Arquivo:</label>
                            <input ref={(ref) => { this.file = ref; }} type="file" name="file"
                                   disabled={importacao.processing === true} />
                            <p className="help-block">
                                Arquivo deve estar no formato CSV do Excel (separados por ponto e vírgula).
                            </p>
                            <p className="help-block">
                                As seguintes colunas devem estar presentes no arquivo CSV: PRODUTO, VENDA FEBRACIS,
                                CATEGORIA e ESTOQUE. Não importa se estão em maiúsculas ou minúsculas.
                            </p>
                            <p className="help-block">
                                O campo VENDA FEBRACIS pode ou não ter "R$" e usar ponto ou vírgula como separador
                                decimal. Por favor, não use separador de milhar. Exemplos:
                            </p>
                            <ol className="help-block">
                                <li>R$ 100,00</li>
                                <li>100,00</li>
                                <li>R$ 100.00</li>
                                <li>100.00</li>
                            </ol>
                            <p className="help-block">
                                O campo PRODUTO deve ter um dos seguintes valores (podem ser maiúsculos ou minúsculos):
                            </p>
                            <ol className="help-block">
                                <li>Produto</li>
                                <li>Curso</li>
                            </ol>
                            <p className="help-block">
                                Certifique-se de converter o arquivo para UTF-8 antes de fazer o upload.
                            </p>
                        </div>

                        <input className="btn btn-primary"
                               disabled={importacao.processing === true}
                               type="button"
                               value={importacao.processing === true ? "Processando..." : "Enviar"}
                               onClick={onUploadFile} />
                    </form>
                </div>

                {tableFails}
            </div>
        );
    }
}

export default ImportacaoProdutos;


// WEBPACK FOOTER //
// src/views/pages/ImportacaoProdutos.jsx